import axios from 'axios'
import { ElMessage } from 'element-plus'

// token拦截器
// Add a request interceptor
axios.interceptors.request.use(function (config) {
    // Do something before request is sent
    const token = localStorage.getItem("token");
    // 只有拿到真实 token 才带 Authorization，避免发出 "Bearer undefined" 这种脏头
    if (token && token !== 'undefined' && token !== 'null') {
        config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
}, function (error) {
    // Do something with request error
    return Promise.reject(error);
});


// Add a response interceptor
axios.interceptors.response.use(function (response) {
    const { authorization } = response.headers;
    authorization && localStorage.setItem("token", authorization);
    return response;
}, function (error) {
    if (error.response && error.response.status) {
        const { status } = error.response;
        console.log('-------------------------------***',status)
        if (status === 401) {
            // 清掉失效的登录态，避免拿着旧 token 反复请求
            localStorage.removeItem("token");
            localStorage.removeItem("userInfo");
            // hash 路由下管理端路径统一以 #/admin 开头，只有管理端才跳登录页；
            // 前台用户页（/works、/points 等）遇到 401 不应被弹去管理端登录页
            if (window.location.hash.startsWith("#/admin")) {
                window.location.href = "#/admin/login";
            }
            return Promise.reject(error);
        }
        if (status === 403) {
            // 权限等级不够（页面没勾、或者没有删除权限）：服务端会带一句人话，直接弹出来
            const msg = error.response.data && error.response.data.message
            // 主人要求：「请先登录B站账号」这句**一概不弹**（哪个页面都不弹）。
            // 它是 B 站会话缺失时 /user/Bmsg、/user/captain 返回的，未登录也能正常看页面，
            // 所以静默处理就好；其它 403（权限不够、没有删除权限）照旧弹出来。
            const LOGIN_HINT = /请先登录\s*B\s*站/
            if (!LOGIN_HINT.test(String(msg || ''))) {
                ElMessage.error(msg || '这个账号没有权限做这件事')
            }
        }
    }
    return Promise.reject(error);
});